'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var _BinaryCheckBoxUtil = require('./BinaryCheckBoxUtil');

var _CheckBox = require('./../Style/CheckBox');

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _BinaryToolTip = require('./../BinaryToolTip');

var _BinaryToolTip2 = _interopRequireDefault(_BinaryToolTip);

var _BinaryBreadCrum = require('./../BinaryBreadCrum');

var _BinaryBreadCrum2 = _interopRequireDefault(_BinaryBreadCrum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var uniqueId = function uniqueId() {
  return Math.random();
};

var BinaryCheckBox = function (_Component) {
  _inherits(BinaryCheckBox, _Component);

  function BinaryCheckBox(props) {
    _classCallCheck(this, BinaryCheckBox);

    var _this = _possibleConstructorReturn(this, (BinaryCheckBox.__proto__ || Object.getPrototypeOf(BinaryCheckBox)).call(this, props));

    var _this$props = _this.props,
        filter = _this$props.filter,
        reset = _this$props.reset,
        prevFilter = _this$props.prevFilter,
        prevFilterData = _this$props.prevFilterData,
        customData = _this$props.customData;

    _this.styles = require('./BinaryCheckBox.scss');
    _this.state = {
      search_value: '',
      filter: filter,
      accordion_expanded: true,
      filter_name: '',
      hierarchy: [],
      original: filter,
      timer: null,
      customData: null,
      current_search_value: null,
      filter_arr: [],
      filter_data: []
    };
    // cancel button
    if (typeof prevFilterData !== 'undefined' && typeof prevFilter !== 'undefined') {
      if (prevFilterData !== null && prevFilter !== null) {
        if (prevFilterData.length > 0) {
          _this.state.filter_data = prevFilterData.concat([]);
        }
        if (Object.keys(prevFilter).length > 0) {
          _this.state.filter = (0, _ramda.merge)({}, prevFilter);
          if (prevFilter.name !== 'Search result') {
            // this.search({target: {value: ':checked'}});
            _this.state.original = (0, _ramda.merge)({}, prevFilter);
          }
        }
      }
    }
    if (prevFilter === null) {
      (0, _BinaryCheckBoxUtil.uncheckAll)(_this.state.filter);
    }
    if (prevFilter !== null && typeof prevFilter !== 'undefined' && Object.keys(prevFilter).length === 0) {
      (0, _BinaryCheckBoxUtil.uncheckAll)(_this.state.filter);
    }

    _this.state.filter_name = filter.name;
    _this.state.filter_arr = (0, _BinaryCheckBoxUtil.convertJsonToLinkedList)(_this.state.original);
    _this.state.customData = (0, _ramda.merge)({}, customData);
    _this.state.hierarchy = _this.getCheckboxHierarchy(_this.state.filter);
    if (typeof reset === 'undefined') {
      _this.state.original = (0, _ramda.merge)({}, filter);
      _this.state.filter = (0, _ramda.merge)({}, filter);
    }
    return _this;
  }

  _createClass(BinaryCheckBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.state.filter_data.length > 0) {
        // this.search({target: {value: ':checked'}});
      }

      var filter = this.props.filter;
      if (typeof location.query === 'undefined' && location.hash) {
        var query = {};
        var locationData = location.hash.split('?')[1].split('&');
        locationData.forEach(function (locationItem) {
          query[locationItem.split('=')[0]] = locationItem.split('=')[1];
        });
        location.query = query;
      }
      var goIn = function goIn(node, ids) {
        if (node.children && Object.keys(node.children) === 0) {
          return;
        }
        if (node.children === null || typeof node.children === 'undefined') {
          return;
        }
        if (ids.indexOf(node.id) !== -1) {
          node.check = true;
        }
        Object.keys(node.children).forEach(function (key) {
          if (ids.indexOf(node.children[key].id) !== -1 || node.children[key].check) {
            node.children[key].check = true;
            if (node.children[key].children && node.children[key].children !== null && Object.keys(node.children[key].children).length > 0) {
              Object.keys(node.children[key].children).forEach(function (key_) {
                node.children[key].children[key_].check = true;
              });
            }
          }
          goIn(node.children[key], ids);
        });
      };
      if (this.state.timer === null) {
        if (filter.name === 'Source') {
          goIn(filter, [parseInt(location.query.source, 10)]);
        }
        if (filter.name === 'Category') {
          goIn(filter, [parseInt(location.query.category, 10)]);
        }
        if (filter.name === 'Provider/Location') {
          goIn(filter, [parseInt(location.query.providerlocation, 10)]);
        }
        if (filter.name === 'Task Owner') {
          if (filter.children.task_all && location.query.taskOwnership === 'a') {
            filter.children.task_all.check = true;
            Object.keys(filter.children.task_all.children).forEach(function (key) {
              filter.children.task_all.children[key].check = true;
            });
          } else {
            if (filter.children.task_all && filter.children.task_all[location.query.taskOwnership]) {
              filter.children.task_all[location.query.taskOwnership].check = true;
            }
          }
        }
      }
      this.setState({ filter: this.props.filter });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.reset && this.props.filter.name !== 'Status') {
        this.handleClearAll();
      }
    }
  }, {
    key: 'getCheckBoxHover',
    value: function getCheckBoxHover(filter) {
      var filterData = Object.assign({}, filter);
      var hierarchy = [];
      var hover = [];
      while (filterData.parent) {
        hierarchy.push(filterData.parent);
        filterData = filterData.parent;
      }
      hierarchy.forEach(function (item) {
        hover.push(item.name);
      });
      return hover.reverse().join(' > ');
    }
  }, {
    key: 'getCheckboxHierarchy',
    value: function getCheckboxHierarchy(filter) {
      var id = filter.id;
      var name = filter.name;
      var hierarchy = [{
        id: id,
        name: name
      }];
      var checkbox = Object.assign({}, filter);

      while (checkbox.parentId !== null && checkbox.parent) {
        hierarchy.push({
          id: checkbox.parent.id,
          name: checkbox.parent.name
        });
        checkbox = checkbox.parent;
      }

      if (hierarchy.length === 1 && typeof hierarchy[0].id !== 'undefined') {
        hierarchy.push(checkbox.parent);
      }

      var newHierarchy = [];
      hierarchy.forEach(function (hierarchyItem) {
        if (hierarchyItem && hierarchyItem.name !== 'All Sources') {
          newHierarchy.push(hierarchyItem);
        }
      });

      return newHierarchy.reverse();
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput() {
      var name = this.state.filter.name ? this.state.filter.name.split(' ').join('_').toLowerCase() : '';
      return _react2.default.createElement(
        'div',
        { className: this.styles.binary_filter_search },
        _react2.default.createElement('i', { className: 'icon-Search' }),
        _react2.default.createElement('input', {
          onChange: this.search.bind(this),
          type: 'text',
          placeholder: 'Search',
          ref: 'search',
          id: 'binary_checkbox_search_' + name,
          maxLength: 80,
          value: this.state.search_value
        })
      );
    }
  }, {
    key: 'getCustomCheckBox',
    value: function getCustomCheckBox() {
      var id = this.state.filter.name ? this.state.filter.name.split(' ').join('_').toLowerCase() + '_' + this.state.customData.value : this.state.customData.value;
      return _react2.default.createElement(
        _CheckBox2.default,
        null,
        _react2.default.createElement('input', {
          defaultChecked: this.state.customData.check ? this.state.customData.check : false,
          ref: this.state.customData.value,
          name: this.state.customData.value,
          key: uniqueId(),
          type: 'checkbox',
          id: id,
          onChange: this.handleCustomClick.bind(this, this.state.customData),
          className: 'binary_checkbox binary_checkbox_custom'
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: id, className: 'binary_checkbox_label binary_checkbox_label_custom' },
          this.state.customData.name
        )
      );
    }
  }, {
    key: 'getCheckBoxes',
    value: function getCheckBoxes() {
      var _this2 = this;

      var _props = this.props,
          allowMultipleSelect = _props.allowMultipleSelect,
          disabled = _props.disabled,
          toolTipPlacement = _props.toolTipPlacement;

      var search = Object.prototype.toString.call(this.state.filter.children) === '[object Array]' ? true : false;
      var CHECKBOX_RENDER = [];
      var filter = this.state.filter;
      var keysinorder = (0, _BinaryCheckBoxUtil.getAlphabetOrderedFilter)(filter);
      keysinorder.forEach(function (key) {
        var original = _this2.state.filter.name ? _this2.state.filter.name.split(' ').join('_').toLowerCase() + '_' + key : key;
        var id = search ? original + '_' + uniqueId() : original;
        var hoverText = _this2.getCheckBoxHover(filter.children[key]);

        CHECKBOX_RENDER.push(_react2.default.createElement(
          _CheckBox2.default,
          { allowMultipleSelect: allowMultipleSelect },
          _react2.default.createElement('input', {
            disabled: disabled,
            defaultChecked: filter.children[key].check ? filter.children[key].check : false,
            ref: key,
            name: filter.children[key].name,
            key: uniqueId(),
            type: 'checkbox',
            id: id,
            onChange: _this2.handleCheckBoxClick.bind(_this2, filter.children[key])
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: id, title: hoverText.split('>').length === 1 ? filter.children[key].name : '' },
            _react2.default.createElement(_BinaryToolTip2.default, {
              key: 'binary_checkbox_tooltip',
              node: _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  filter.children[key].name
                )
              ),
              data: hoverText.split('>').length > 1 && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  hoverText
                )
              ),
              placement: toolTipPlacement ? toolTipPlacement : 'left'
            }),
            filter.children[key].children !== null && typeof filter.children[key].children !== 'undefined' && Object.keys(filter.children[key].children).length !== 0 && _react2.default.createElement(
              'span',
              {
                id: _this2.state.filter.name ? _this2.state.filter.name.split(' ').join('_').toLowerCase() + '_inner_' + key : key,
                className: _this2.styles.binary_checkbox_label_level_down,
                onClick: _this2.handleInnerClick.bind(_this2, filter.children[key])
              },
              _react2.default.createElement('i', { className: 'icon-Down' })
            )
          )
        ));
      });
      // if (CHECKBOX_RENDER.length === 0) { return <p>There are no data.</p>; }
      return CHECKBOX_RENDER.length > 1000 ? _react2.default.createElement(
        'div',
        null,
        CHECKBOX_RENDER.slice(0, 1000),
        _react2.default.createElement(
          'p',
          null,
          'There are so many data. Please use search to display more data.'
        )
      ) : _react2.default.createElement(
        'div',
        null,
        CHECKBOX_RENDER
      );
    }
  }, {
    key: 'search',
    value: function search(event) {
      var _this3 = this;

      this.setState({
        search_value: event.target.value
      }, function () {
        if (_this3.props.handleBreadCrumClick) {
          _this3.props.handleBreadCrumClick();
        }
      });

      if (event.target.value.trim() === '') {
        var newFilter = this.state.original;
        while (typeof newFilter.parent !== 'undefined' && newFilter.parentId !== null) {
          newFilter = newFilter.parent;
        }
        this.setState({
          filter: (0, _ramda.merge)({}, newFilter),
          hierarchy: this.getCheckboxHierarchy(newFilter),
          original: (0, _ramda.merge)({}, newFilter),
          filter_arr: (0, _BinaryCheckBoxUtil.convertJsonToLinkedList)(newFilter)
        }, function () {
          if (_this3.props.handleBreadCrumClick) {
            _this3.props.handleBreadCrumClick();
          }
        });
        return;
      }
      if (event.target.value.length < 3) {
        return;
      }
      this.setState({
        filter: Object.assign({}, this.state.original),
        hierarchy: this.getCheckboxHierarchy(this.state.original),
        current_search_value: _extends({}, event)
      }, function () {
        // only trigger the autocomplete if user not typing after 500 ms
        if (_this3.props.handleBreadCrumClick) {
          _this3.props.handleBreadCrumClick();
        }

        clearTimeout(_this3.state.timer);
        _this3.state.timer = setTimeout(function () {
          var SEARCH_RESULT = {
            children: [],
            name: 'Search result',
            parentId: null,
            type: 'checkbox'
          };
          var input = _this3.progressInput(_this3.state.current_search_value.target.value.toLowerCase());
          if (input === ':checked') {
            SEARCH_RESULT.children = _this3.state.filter_data;
          } else {
            var _newFilter = _this3.state.original;
            while (typeof _newFilter.parent !== 'undefined' && _newFilter.parentId !== null) {
              _newFilter = _newFilter.parent;
            }
            _this3.setState({ hierarchy: _this3.getCheckboxHierarchy(_newFilter) });
            SEARCH_RESULT.children = (0, _BinaryCheckBoxUtil.autoCompleteFromLinkedList)((0, _BinaryCheckBoxUtil.convertJsonToLinkedList)(_newFilter), input, _this3.props.searchInclude);
          }
          if (input === '') {
            _this3.setState({
              filter: Object.assign({}, _this3.state.original)
            }, function () {
              if (_this3.props.handleBreadCrumClick) {
                _this3.props.handleBreadCrumClick();
              }
            });
          } else {
            SEARCH_RESULT.children = SEARCH_RESULT.children.slice(0, 10);
            _this3.setState({
              filter: SEARCH_RESULT
            }, function () {
              if (_this3.props.handleBreadCrumClick) {
                _this3.props.handleBreadCrumClick();
              }
            });
          }
        }, 500);
      });
    }
  }, {
    key: 'progressInput',
    value: function progressInput(value) {
      var returnValue = '';
      var valueArr = value.split(' ');
      returnValue = valueArr.map(function (item) {
        return item.charAt(0).toUpperCase() + item.slice(1);
      });
      returnValue = returnValue.join(' ');
      return returnValue;
    }
  }, {
    key: 'handleBreadCrumClick',
    value: function handleBreadCrumClick(hierarchy) {
      var _this4 = this;

      var originalFilter = null;
      var loopFilter = Object.assign({}, this.state.original);
      // get first level
      if (loopFilter.parent) {
        while (loopFilter.parent.parentId !== null) {
          loopFilter = loopFilter.parent;
        }
        originalFilter = Object.assign({}, loopFilter.parent);
      } else {
        originalFilter = Object.assign({}, loopFilter);
      }

      var newFilter_ = [];
      hierarchy.map(function (item) {
        // first item is the root one so id is undefined
        if (typeof item.id !== 'undefined' && originalFilter.children !== null) {
          Object.keys(originalFilter.children).forEach(function (originalFilterKey) {
            if (originalFilterKey + '' === item.id + '') {
              newFilter_.push(originalFilter.children[item.id]);
              originalFilter = Object.assign({}, originalFilter.children[item.id]);
            }
          });
        }
      });
      var filter = Object.assign({}, originalFilter);
      if (originalFilter.parent) {
        filter = Object.assign({}, originalFilter.parent);
      }
      this.setState({
        filter: filter,
        hierarchy: this.getCheckboxHierarchy(originalFilter)
      }, function () {
        if (_this4.props.handleBreadCrumClick) {
          _this4.props.handleBreadCrumClick();
        }
      });
    }
  }, {
    key: 'handleInnerClick',
    value: function handleInnerClick(filter) {
      if (filter.children !== null && typeof filter.children !== 'undefined') {
        this.setState({
          filter: Object.assign({}, filter),
          hierarchy: this.getCheckboxHierarchy(filter),
          search_value: ''
        });
      }
    }
  }, {
    key: 'handleCheckBoxClick',
    value: function handleCheckBoxClick(filter) {
      var _this5 = this;

      var allowMultipleSelect = this.props.allowMultipleSelect;

      // if search, filter will have children as an array instead of object

      if (!allowMultipleSelect) {
        var searchText = this.state.search_value;
        this.handleClearAll(function () {
          _this5.search({ target: { value: searchText } });
          _this5.handleCheckBoxClickCollectData(filter, true);
        }, false);
      } else {
        this.handleCheckBoxClickCollectData(filter);
      }
    }
  }, {
    key: 'handleCheckBoxClickCollectData',
    value: function handleCheckBoxClickCollectData(filter) {
      var _this6 = this;

      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var collectFilterData = this.props.collectFilterData;

      var search = Object.prototype.toString.call(this.state.filter.children) === '[object Array]' ? true : false;
      var original_ = (0, _BinaryCheckBoxUtil.handleCheckForLinkedList)(filter);
      var filter_ = this.state.filter;
      var filterdata_ = (0, _BinaryCheckBoxUtil.getHighestLevelOfCheckedNodes)(filter_);
      if (search && typeof filter_.children.length !== 'undefined') {
        filter_.children = (0, _BinaryCheckBoxUtil.autoCompleteFromLinkedList)(this.state.filter_arr, this.state.search_value);
        filter_.children = filter_.children.slice(0, 10);
        filterdata_ = filterdata_.length === 0 || reset ? (0, _BinaryCheckBoxUtil.getHighestLevelOfCheckedNodes)(this.state.original) : filterdata_;
        if (reset && filterdata_[0]) {
          filter_ = filterdata_[0].parent;
        }
      }
      if (this.state.customData.check) {
        filterdata_.push(this.state.customData);
      }
      this.setState({
        original: Object.assign({}, original_),
        filter: Object.assign({}, filter_),
        hierarchy: this.getCheckboxHierarchy(filter_),
        filter_data: filterdata_.concat([])
      }, function () {
        /* this.setState({
          hierarchy: this.getCheckboxHierarchy(this.state.filter)
        }); */
        collectFilterData(_this6.state.filter_data, _this6.state.filter);
      });
    }
  }, {
    key: 'handleCustomClick',
    value: function handleCustomClick() {
      var _this7 = this;

      var collectFilterData = this.props.collectFilterData;

      var customData_ = Object.assign({}, this.state.customData);
      customData_.check = !this.state.customData.check;
      var filterdata_ = this.state.filter_data.concat([]);

      if (customData_.check) {
        filterdata_.push(customData_);
      } else {
        // remove custom out of filter data (checkbox selected)
        filterdata_.forEach(function (item, index) {
          if (item.id === customData_.id) {
            filterdata_.splice(index, 1);
          }
        });
      }

      this.setState({
        customData: customData_,
        filter_data: filterdata_.concat([])
      }, function () {
        collectFilterData(_this7.state.filter_data, _this7.state.filter);
      });
    }
  }, {
    key: 'handleClearAll',
    value: function handleClearAll(callback) {
      var _this8 = this;

      var reloadFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _props2 = this.props,
          allowMultipleSelect = _props2.allowMultipleSelect,
          collectFilterData = _props2.collectFilterData,
          customData = _props2.customData;

      var filterOriginal = (0, _BinaryCheckBoxUtil.uncheckAll)(this.state.original);
      (0, _BinaryCheckBoxUtil.uncheckAll)(this.state.filter);
      (0, _BinaryCheckBoxUtil.uncheckAll)(this.state.original);
      this.state.filter_arr.forEach(function (filterItem) {
        (0, _BinaryCheckBoxUtil.uncheckAll)(filterItem);
      });

      var stateObject = {
        filter: this.state.filter.children === null && typeof this.state.filter.parent !== 'undefined' ? this.state.filter.parent : this.state.filter,
        original: this.state.original.children === null && typeof this.state.original.parent !== 'undefined' ? this.state.original.parent : this.state.original,
        search_value: '',
        filter_data: (0, _BinaryCheckBoxUtil.getHighestLevelOfCheckedNodes)(filterOriginal),
        customData: (0, _ramda.merge)({}, customData)
      };
      if (allowMultipleSelect || !allowMultipleSelect && reloadFilter) {
        stateObject.filter = Object.assign({}, filterOriginal);
        stateObject.hierarchy = this.getCheckboxHierarchy(filterOriginal);
      }
      this.setState(stateObject, function () {
        collectFilterData(_this8.state.filter_data, Object.assign({}, _this8.state.filter));
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      // filterData
      var _props3 = this.props,
          search = _props3.search,
          disabled = _props3.disabled,
          containerclassName = _props3.containerclassName;

      return _react2.default.createElement(
        'div',
        { ref: 'checkbox_container' },
        search && !disabled && this.getSearchInput(),
        !disabled && this.state.customData.id && this.getCustomCheckBox(),
        _react2.default.createElement(_BinaryBreadCrum2.default, {
          style: { fontSize: '12px' },
          hierarchy: this.state.hierarchy,
          handleBreadCrumClick: this.handleBreadCrumClick.bind(this) }),
        !disabled && _react2.default.createElement(
          'div',
          { key: this.state.filter.name, className: this.styles.binary_filter_all_item + ' ' + containerclassName },
          this.getCheckBoxes(),
          this.state.filter && this.state.filter.children !== null && this.state.filter.children && this.state.filter.children.length === 0 && _react2.default.createElement(
            'p',
            { id: this.state.filter.name ? this.state.filter.name.split(' ').join('_').toLowerCase() + '_noresult' : 'noresult' },
            'No Results Found!'
          )
        ),
        !disabled && _react2.default.createElement(
          'div',
          {
            id: this.state.filter.name ? 'binary_filter_clearall_' + this.state.filter.name.split(' ').join('_').toLowerCase() : 'binary_filter_clearall',
            onClick: function onClick() {
              _this9.handleClearAll(function () {
                _this9.handleClearAll(undefined);
              });
            },
            className: this.styles.clear_all + ' ' + 'clear_all_' + this.state.filter.name.toLowerCase() },
          'clear all'
        )
      );
    }
  }]);

  return BinaryCheckBox;
}(_react.Component);

BinaryCheckBox.propTypes = {
  disabled: _propTypes2.default.bool,
  filter: _propTypes2.default.object.isRequired,
  filterData: _propTypes2.default.array,
  reset: _propTypes2.default.bool,
  prevFilter: _propTypes2.default.object,
  prevFilterData: _propTypes2.default.array,
  customData: _propTypes2.default.object,
  collectFilterData: _propTypes2.default.func.isRequired,
  toolTipPlacement: _propTypes2.default.string,
  search: _propTypes2.default.bool,
  allowMultipleSelect: _propTypes2.default.bool,
  containerclassName: _propTypes2.default.string,
  handleBreadCrumClick: _propTypes2.default.func,
  location: _propTypes2.default.object,
  searchInclude: _propTypes2.default.array
};
BinaryCheckBox.defaultProps = {
  searchInclude: [],
  disabled: false
};
exports.default = BinaryCheckBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryCheckBox/BinaryCheckBox.js
// module id = 2167
// module chunks = 1